import { Component, OnInit, EventEmitter, Input, Output, ComponentFactoryResolver } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { QuestionnaireService } from '../services/questionnaire.service';
@Component({
  selector: 'app-line-other-income',
  templateUrl: './line-other-income.component.html',
  styleUrls: ['./line-other-income.component.scss']
})
export class LineOtherIncomeComponent implements OnInit {
  @Input() qID: number = null;
  @Input() public type: string[];
  @Input() public titles: string[];
  @Input() public needSources: boolean;
  @Input() public index: number;
  @Input() public income: FormGroup;
  @Output() public removed: EventEmitter<number> = new EventEmitter<number>();
  @Output() public changeInput: EventEmitter<number> = new EventEmitter<number>();
  @Output() public clickInput: EventEmitter<number> = new EventEmitter<number>();
  @Input() public displayErrors: boolean;
  @Input() public ph: string;
  @Input() public displayX: boolean;
  showErrorOtherIncomes: boolean = false;
  defaultValue = "";
  isDisabled: boolean = false;



  constructor(private questionnaireService: QuestionnaireService,) { }

  ngOnInit() {
    let tmp = []
    let flag = 1;
    this.type.forEach((t, i) => {
      if (t === 'אין לי הכנסות נוספות') {
        flag = 2;
      }
      else {
        tmp.push(t)
      }
    }
    )
    if (flag === 2) {
      tmp.unshift("אין לי הכנסות נוספות")
    }
    this.type = tmp;
    this.income.controls.type.valueChanges.subscribe(res => {
      if (this.income.controls.type.value === 'אין לי הכנסות נוספות') {
        this.income.controls.amount.disable();
        this.income.controls.amount.patchValue(0)
        this.isDisabled = true;
      }
      else {
        this.income.controls.amount.enable();
        this.isDisabled = false;
      }

      // if (this.income.controls.type.value !== 'אחר') {
      this.income.controls.source.clearValidators();
      this.income.controls.source.patchValue('');
      // } else {
      //   this.income.get('source').setValidators([Validators.required, Validators.min(1)]);

      // }
      this.income.updateValueAndValidity();
    });

    this.questionnaireService.showErrorOtherIncomes$.subscribe(val => {
      if (val) {
        this.showErrorOtherIncomes = true;
      }
    })
  }

  static buildIncome(val: any) {
    return new FormGroup({
      type: new FormControl(val[0] ? val[0].answerValue : ""),
      amount: new FormControl(val[1] ? val[1].answerValue : 0),
      source: new FormControl(val[2] ? val[2].answerValue : "")
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/line-other-income/line-other-income.component.ts